const shadows = {} as const;

export default shadows;

export type ThemeShadows = typeof shadows;
export type ThemeShadowsKeys = keyof typeof shadows;
